// Public Study View - Wrapper qui charge les données publiques et affiche AppContent en mode public
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { AppContent } from '../App';
import '../App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PublicStudyView = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [studyData, setStudyData] = useState(null);
  const [shareInfo, setShareInfo] = useState(null);

  useEffect(() => {
    fetchStudyData();
  }, [token]);

  const fetchStudyData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API}/public/study/${token}`);
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Lien invalide ou expiré');
      }
      
      const data = await response.json();
      setStudyData(data.study);
      setShareInfo(data.share_info);
    } catch (err) {
      console.error('Error fetching study:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen" style={{ background: '#F5F6F9' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '40px', height: '40px', border: '3px solid #E2E6EA', borderTopColor: '#397DFF', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
          <p style={{ fontFamily: 'var(--font-corps)', fontSize: '0.9375rem', color: '#687175' }}>Chargement de l'étude...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen" style={{ background: '#F5F6F9' }}>
        <div style={{
          textAlign: 'center',
          padding: '48px',
          background: 'white',
          borderRadius: '14px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          maxWidth: '500px'
        }}>
          <div style={{
            width: '56px',
            height: '56px',
            background: '#FEF2F2',
            borderRadius: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px'
          }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#DC2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          </div>
          <h2 style={{ color: '#191D1E', fontFamily: 'var(--font-titre)', fontWeight: '600', marginBottom: '8px' }}>Lien non valide</h2>
          <p style={{ color: '#687175', margin: 0, fontFamily: 'var(--font-corps)' }}>{error}</p>
        </div>
      </div>
    );
  }

  // Créer l'objet latestAnalysis compatible avec les composants existants
  // Les données sont directement dans studyData, pas dans latest_analysis
  const latestAnalysis = {
    analysis_id: studyData?.id,
    name: studyData?.name,
    client_info: studyData?.client_info,
    sites: studyData?.sites,
    supplier_offers: studyData?.supplier_offers,
    supplier_analysis: studyData?.supplier_analysis,
    total_sites: studyData?.sites?.length || 0,
    recommendation: studyData?.recommendation,
    recommended_supplier: studyData?.recommended_supplier
  };

  // Render AppContent avec isPublicView=true
  return (
    <AppContent 
      isPublicView={true}
      publicData={latestAnalysis} 
      publicShareInfo={shareInfo}
    />
  );
};

export default PublicStudyView;
